import React from 'react';
import { TwitterIcon, LinkedinIcon, GithubIcon } from 'lucide-react';
const columns = [{
  title: 'Product',
  links: ['Features', 'Signal feed', 'Attribution', 'Alerts', 'Dashboards', 'Changelog']
}, {
  title: 'Integrations',
  links: ['HubSpot', 'Salesforce', 'GA4', 'Google Ads', 'Meta Ads', 'View all']
}, {
  title: 'Company',
  links: ['About', 'Careers', 'Customers', 'Blog', 'Press']
}, {
  title: 'Resources',
  links: ['Docs', 'API reference', 'Guides', 'Status', 'Security']
}, {
  title: 'Legal',
  links: ['Privacy', 'Terms', 'DPA', 'Cookies']
}];
export function Footer() {
  return <footer className="bg-ink text-cream" data-id="element-47">
      <div className="mx-auto max-w-[1200px] px-5 py-16 md:px-8 md:py-20" data-id="element-48">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_repeat(5,1fr)]" data-id="element-49">
          <div data-id="element-50">
            <a href="#top" className="flex items-center gap-2" data-id="element-51">
              <span className="h-3 w-3 rounded-full bg-signal" data-id="element-52" />
              <span className="font-display text-xl font-semibold" data-id="element-53">
                oursignals
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm text-cream/60" data-id="element-54">
              Every marketing and sales signal, unified into one live source of
              truth.
            </p>
            <div className="mt-6 flex gap-3" data-id="element-55">
              {[TwitterIcon, LinkedinIcon, GithubIcon].map((Icon, i) => <a key={i} href="#top" className="flex h-9 w-9 items-center justify-center rounded-full border border-cream/20 text-cream/70 transition-colors hover:border-signal hover:text-signal" aria-label="social link" data-id="element-56">
                  <Icon className="h-4 w-4" data-id="element-57" />
                </a>)}
            </div>
          </div>

          {columns.map(col => <div key={col.title} data-id="element-58">
              <h3 className="text-xs font-semibold uppercase tracking-widest text-cream/40" data-id="element-59">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2.5" data-id="element-60">
                {col.links.map(link => <li key={link} data-id="element-61">
                    <a href="#top" className="text-sm text-cream/70 transition-colors hover:text-signal" data-id="element-62">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-cream/15 pt-8 text-sm text-cream/50 md:flex-row md:items-center" data-id="element-63">
          <p data-id="element-64">
            © {new Date().getFullYear()} oursignals.co — All rights reserved.
          </p>
          <p data-id="element-65">Made for revenue teams who read the signal.</p>
        </div>
      </div>
    </footer>;
}